import { documentationActions } from '../../actions/constant';

const {
  SUCCESS_CALL_SUBMISSION_EVENT,
  FAILURE_CALL_SUBMISSION_EVENT,
  RESET_CALL_SUBMISSION_EVENT,
  LOADING_SAVE_SUBMISSION,
} = documentationActions;

const intitialstate: object = {
  response: null,
  isEventCalled: false,
  loading: false,
};

export const callSubmitEventReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_CALL_SUBMISSION_EVENT: {
      return {
        ...state,
        isEventCalled: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case FAILURE_CALL_SUBMISSION_EVENT:
      return {
        ...state,
        isEventCalled: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_SAVE_SUBMISSION:
      return {
        ...state,
        loading: true,
      };

    case RESET_CALL_SUBMISSION_EVENT:
      return intitialstate;

    default:
      return state;
  }
};
